import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import {
    TextField,
    Button,
    Box,
    Card,
    CardContent,
    Typography,
    IconButton,
    InputAdornment,
    CircularProgress
} from '@mui/material';
import PageHeader1 from '../../components/common/PageHeader1';
import { toast } from 'react-hot-toast';

function BookingPassword() {
    const navigate = useNavigate();

    // Update Password States
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showCurrentPass, setShowCurrentPass] = useState(false);
    const [showNewPass, setShowNewPass] = useState(false);
    const [showConfirmPass, setShowConfirmPass] = useState(false);
    const [loading, setLoading] = useState(false);

    const token = localStorage.getItem('vedhvidhi-admin-token');

    const handleUpdatePassword = async () => {
        if (!currentPassword || !newPassword || !confirmPassword) {
            toast.error('Please fill all update password fields');
            return;
        }
        if (newPassword !== confirmPassword) {
            toast.error('New password and confirm password do not match');
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASEURL}/admin/chat-password/update`,
                {
                    oldPassword: currentPassword,
                    newPassword: newPassword
                },
                { headers: { Authorization: token } });

            if (response.data.status) {
                toast.success(response.data.message || 'Password updated successfully');
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            } else {
                toast.error(response.data.message || 'Failed to update password');
            }
        } catch (error) {
            console.error('Update error:', error);
            toast.error(error.response?.data?.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="body d-flex py-1">
            <div className="container-xxl">
                <button
                    onClick={() => navigate(-1)}
                    style={{
                        marginBottom: "10px",
                        backgroundColor: "transparent",
                        border: "none",
                        cursor: "pointer",
                        fontFamily: "monospace",
                        fontSize: "18px",
                        color: "#007bff",
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        padding: "10px 20px",
                    }}
                >
                    <span style={{ marginRight: "8px" }}>&lt;</span>
                    <span style={{ position: "relative", display: "inline-block" }}>
                        Back
                        <span
                            style={{
                                content: "''",
                                position: "absolute",
                                left: 0,
                                bottom: -2,
                                width: "100%",
                                height: "1px",
                                borderBottom: "2px solid #007bff",
                            }}
                        ></span>
                    </span>
                </button>
                <PageHeader1 pagetitle="Booking Password Management" />

                <div className="row g-4 mt-2 justify-content-center">
                    {/* Update Password Card */}
                    <div className="col-12">
                        <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.08)', borderRadius: '12px' }}>
                            <CardContent className="p-4">
                                <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, color: '#333' }}>
                                    Update Password
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 4, color: '#666' }}>
                                    Change your existing booking protection password.
                                </Typography>

                                <Box component="form" noValidate>
                                    <TextField
                                        margin="normal"
                                        fullWidth
                                        label="Current Password"
                                        type={showCurrentPass ? 'text' : 'password'}
                                        value={currentPassword}
                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                        variant="outlined"
                                        sx={{ mb: 2 }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => setShowCurrentPass(!showCurrentPass)} edge="end">
                                                        {showCurrentPass ? <i className="icofont-eye-blocked" /> : <i className="icofont-eye" />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <TextField
                                        margin="normal"
                                        fullWidth
                                        label="New Password"
                                        type={showNewPass ? 'text' : 'password'}
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        variant="outlined"
                                        sx={{ mb: 2 }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => setShowNewPass(!showNewPass)} edge="end">
                                                        {showNewPass ? <i className="icofont-eye-blocked" /> : <i className="icofont-eye" />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <TextField
                                        margin="normal"
                                        fullWidth
                                        label="Confirm New Password"
                                        type={showConfirmPass ? 'text' : 'password'}
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        variant="outlined"
                                        sx={{ mb: 1 }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => setShowConfirmPass(!showConfirmPass)} edge="end">
                                                        {showConfirmPass ? <i className="icofont-eye-blocked" /> : <i className="icofont-eye" />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    
                                    <Box sx={{ textAlign: 'right', mb: 3 }}>
                                        <Link 
                                            to="/booking-password/Forget" 
                                            style={{ 
                                                color: '#7258db', 
                                                textDecoration: 'none', 
                                                fontSize: '0.9rem',
                                                fontWeight: 500
                                            }}
                                        >
                                            Forget Password?
                                        </Link>
                                    </Box>

                                    <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={handleUpdatePassword}
                                        disabled={loading}
                                        sx={{
                                            py: 1.5,
                                            backgroundColor: '#7258db',
                                            '&:hover': { backgroundColor: '#5e44c4' },
                                            borderRadius: '8px',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        {loading ? <CircularProgress size={24} color="inherit" /> : 'UPDATE PASSWORD'}
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BookingPassword;
